import SportsHeroListItem from './SportsHeroListItem';

export default SportsHeroListItem;
